<template>
  <div class="page-template add-page" v-loading="loading">
    <div class="page-title">{{ title }}</div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="audit(3)" type="primary" plain :disabled="formModel.reviewerStatus === null">审核</el-button>
      <el-button @click="supplierChange" type="primary" plain>对账查询</el-button>
    </div>
    <list-operation-form
      ref="listOperationForm"
      :formOptions="listFormOptions"
      @valueChange="listFormValueChange">
    </list-operation-form>
    <list-operation ref="listOperation" :tableOptions="listColumns"
                    @selectRowChange="selectShowChange"></list-operation>
  </div>
</template>
<script>

  //添加要货单组件
  import listOperation from '@/components/template/listOperation';
  //要货单搜索组件
  import listOperationForm from '@/components/template/listOperationForm';
  import api from '@/config/api';

  // 数据权限
  import userPower from "@/mixin/userPower";

  export default {
    mixins: [userPower],
    components: {
      listOperation,
      listOperationForm
    },
    data() {
      return {
        isExistNullPrince: 0,
        formModel: {reviewerStatus: null},
        loading: false,
        title: '',
        listShow: false,
        dialogShow: false,
        dataRows: [],
        //头部条件
        listFormOptions: {
          disabled: false,
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
          },
          labelWidth: '130px',
          columns: [
            {
              prop: 'id',
              hidden: true
            },
            {
              label: '业务单号',
              type: 'input',
              prop: 'orderNo',
              span: 8,
              disabled: true,
            }, {
              label: "门店",
              type: "storeInputDialog",
              prop: "storeId",
              disabled: false,
              isHasAll: true,
              span: 8,
            }, {
              label: '供应商',
              type: 'supplierInputDialog',
              prop: 'supplierId',
              params: {type: 20},
              // data: [],
              span: 8,
              // change: this.supplierChange,
              rule: [
                {required: true, message: '请选择供应商', trigger: 'change'},
              ],
            },
            {
              label: '付款金额',
              prop: 'billAmount',
              type: 'input',
              span: 8,
              disabled: true
            }, {
              label: '开卡银行',
              prop: 'bankName',
              type: 'input',
              span: 8
            }, {
              label: '银行账号',
              prop: 'bankAccount',
              type: 'input',
              span: 8
            }, {
              label: '备注',
              type: 'input',
              prop: 'remarks',
              span: 8,
            }
          ]
        },
        // 添加表格字段
        listColumns: {
          height: this.height,
          summaryColumns: ['payAmount', 'amountPaid', 'discountedAmount', 'outstandAmount', 'actualPayAmount', 'discountMoney'],
          showSelect: true,
          disabled: false,
          columns: [
            {label: '序号', type: 'index', width: 80, prop: 'idx'},
            {
              label: '单据号',
              prop: 'billOrderNo',
              width: '180',
              align: "center",
              callback: this.goOrderDetail,
            },
            {
              label: "单据类型",
              prop: "type",
              width: '120',
              align: "center",
              enumData: this.$utils.getCacheStatus('stJointSettlementMap.type')
            },
            {
              label: "单据日期",
              prop: "billDttm",
              width: '90',
              align: "center"
            },
            {
              label: '应付金额',
              width: '90',
              prop: 'payAmount',
              align: "center",
            },
            {
              label: '已付金额',
              width: '125',
              prop: 'amountPaid',
              align: "center"
            },
            {
              label: '已优惠金额',
              width: '90',
              prop: 'discountedAmount',
              align: "center"
            },
            {
              label: '未付金额',
              width: '90',
              prop: 'outstandAmount',
              align: "center"
            },
            {
              label: '实付金额',
              width: '90',
              prop: 'actualPayAmount',
              align: "center",
              type: 'inputNumber',
              min: -Infinity,
              precision: 2,
              change: this.payAmountChange
            },
            {
              label: '优惠金额',
              width: '90',
              prop: 'discountMoney',
              align: "center",
              type: 'inputNumber',
              precision: 2
            },
            {
              label: '备注',
              prop: 'remarks',
              width: '90',
              align: "center"
            },
          ]
        },
        checkIndex: '',
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '350px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              span: 12,
            }, {
              label: '门店',
              prop: 'storeName',
              span: 12,
            },
            {
              label: '开始日期',
              prop: 'startDttm',
              span: 12,
            },
            {
              label: '结束日期',
              prop: 'endDttm',
              span: 12,
            }, {
              label: '供应商',
              prop: 'supplierName',
              span: 12,
            },
            {
              label: '备注',
              prop: 'remarks',
              span: 12,
            }],
          tablesProp: {
            stJointBillMapMVOList: {
              tableName: "stJointBillMapMVOList",
              summaryColumns: ['goodsNum', 'saleAmount', 'shareNum', 'payAmount'],
              columns: [
                {
                  label: '商品条码',
                  prop: 'goodsBarCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "价格",
                  prop: "retailPrice",
                  width: '90',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsNum',
                  align: "center",
                },
                {
                  label: '销售金额',
                  width: '90',
                  prop: 'saleAmount',
                  align: "center",
                },
                {
                  label: '扣率',
                  width: '90',
                  prop: 'discountRate',
                  align: "center",
                },
                {
                  label: '销售日期',
                  width: '125',
                  prop: 'saleDttm',
                  align: "center"
                },
                {
                  label: '分成金额',
                  width: '125',
                  prop: 'shareNum',
                  align: "center"
                },
                {
                  label: '应付金额',
                  width: '125',
                  prop: 'payAmount',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },

          // 打印的列表
          printTablesProp: {
            stJointBillMapMVOList: {
              tableName: 'stJointBillMapMVOList',
              showSummary: true,
              summaryColumns: ['goodsNum', 'saleAmount', 'shareNum', 'payAmount'],
              columns: [
                {
                  label: '商品条码',
                  prop: 'goodsBarCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "价格",
                  prop: "retailPrice",
                  width: '90',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsNum',
                  align: "center",
                },
                {
                  label: '销售金额',
                  width: '90',
                  prop: 'saleAmount',
                  align: "center",
                },
                {
                  label: '扣率',
                  width: '90',
                  prop: 'discountRate',
                  align: "center",
                },
                {
                  label: '销售日期',
                  width: '125',
                  prop: 'saleDttm',
                  align: "center"
                },
                {
                  label: '分成金额',
                  width: '125',
                  prop: 'shareNum',
                  align: "center"
                },
                {
                  label: '应付金额',
                  width: '125',
                  prop: 'payAmount',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.settle.jointBill
        }
      }
    },
    beforeCreate() {
      this.height = document.documentElement.clientHeight - 180 - 300
    },
    created() {
      this.setStoreId(this.listFormOptions.columns);
      this.title = (this.$route.query.id ? '编辑' : '新增') + document.title;
      if (this.$route.query.id) {
        this.getDetail();
      }
    },
    methods: {
      listFormValueChange(value, column) {
        if (column.prop == "storeId") {
          this.$refs.listOperationForm.$refs.supplierInputDialog[0].initData();
          this.$refs.listOperationForm.formModel.supplierId = "";
          this.$refs.listOperationForm.formModel.storeId = value.id;
          this.$refs["listOperation"].clearTableData();
          this.listFormOptions.columns.filter(
            item => item.prop === "supplierId"
          )[0].params = {storeId: value.id, type: 20};
        }
        if (column.prop == "supplierId") {
          this.$refs["listOperation"].clearTableData();
        }
      },
      payAmountChange() {
        if (this.dataRows.length > 0) {
          let billAmount = 0;
          this.dataRows.map(item => {
            billAmount = billAmount + parseFloat(item.actualPayAmount);
          });
          this.$refs.listOperationForm.formModel.billAmount = billAmount.toFixed(2);
        }
      },
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        const {href} = this.$router.resolve({
          name: "BillJointDetail",
          query: {id: row.billId},
        });
        window.open(href, "_blank");
      },
      //编辑
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.settle.jointSettlement + '?id=' + this.$route.query.id, {}).then(data => {
          this.formModel = data.data;
          if (this.formModel.reviewerStatus === 10) {
            this.listFormOptions.disabled = true;
            this.listColumns.disabled = true;
          }
          this.loading = false;
          if (data.code === 200) {
            this.listFormOptions.columns.filter(item => item.prop === 'supplierId')[0].disabled = true;
            this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
            //为头部表单赋值
            this.$refs.listOperationForm.formModel = data.data;
            if (data.data.storeId === null) {
              this.$refs.listOperationForm.formModel.storeId = '';
            }
            //为表格赋值
            this.$refs['listOperation'].addMoreRow(data.data.stJointSettlementMapList, 0);
            this.$nextTick(() => {
              this.$refs['listOperation'].selectAll();
            });
          } else {
            this.$message({message: data.msg, type: 'error'});
          }
        }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        });
      },

      //提交数据
      submitAuth(e) {
        //获取选择的list数据
        let tableList = this.$refs['listOperation'].selectRows;
        //将合计的值重新赋值给后端接收的参数
        let totalParam = this.$refs['listOperation'].getSumData();
        //将表头的值重新赋值给后端接收的参数
        let headParam = this.$refs.listOperationForm.getFormModel();
        headParam.reviewerStatus = 20;
        console.log(headParam);
        let searchParam = {
          ...{stJointSettlementMapList: tableList}, ...totalParam, ...headParam
        };
        if (tableList.length === 0) {
          this.$message({message: "请勾选数据！", type: "warning"});
        } else {
          if (tableList[tableList.length - 1].id !== undefined) {
            this.saveData(headParam, e, searchParam);
          } else {
            this.$message({message: "请勿勾选合计数据！", type: "warning"});
          }
        }
      },

      saveData(headParam, e, searchParam) {
        if (headParam.id) {
          if (e === 3) {
            this.$confirm("是否确认审核?", "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            ).then(() => {
              this.handleRequest(this.$axios
                .fetchPost(api.settle.jointSettlement + '/joint/settlement/audit', searchParam), e);
            }).catch(() => this.$message({message: "审核取消！", type: "info"}));
          } else {
            this.$confirm("是否确认保存?", "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            ).then(() => {
              this.handleRequest(this.$axios
                .fetchPut(api.settle.jointSettlement, searchParam), e);
            }).catch(() => this.$message({message: "保存取消！", type: "info"}));
          }
        } else {
          this.$confirm("是否确认保存?", "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          ).then(() => {
            this.handleRequest(this.$axios
              .fetchPost(api.settle.jointSettlement, searchParam), e);
          }).catch(() => this.$message({message: "保存取消！", type: "info"}));
        }
      },
      //处理添加和编辑的请求
      handleRequest(parm, e) {
        parm.then(data => {
          this.loading = false;
          if (data.code === 200) {
            if (e === 3) {
              this.$notify({
                type: "success",
                title: '审核操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: "审核成功！", type: "success"});
              this.$router.push({path: '/settlement/joint'});
            } else {
              this.$notify({
                type: "success",
                title: '保存操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: "保存成功！", type: "success"});
              this.dialogShow = false;
              this.$refs.listOperationForm.formModel = data.data;
              this.formModel.reviewerStatus = data.data.reviewerStatus;
            }
          } else {
            if (e === 3) {
              this.$notify({
                type: "error",
                title: '审核操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: "审核失败！", type: "error"});
            } else {
              this.$notify({
                type: "error",
                title: '保存操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: "保存失败！", type: "error"});
            }
          }
        })
          .catch(err => {
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          });
      },

      //返回按钮事件
      beBack() {
        this.$router.go(-1);
      },
      refresh(e) {
        this.$router.go(0);
      },
      // 审核
      audit(e) {
        this.submitAuth(e);
      },
      //门店登录的时候是不可编辑的
      getStore(params) {
        this.$axios.fetchPost(api.store.store + '/list', {}).then(data => {
          if (data.code === 200) {
            data.data.unshift({id: -1, name: '总部'});
            params.filter((item) => item.prop === "storeId")[0].data = data.data;
          } else {
            this.$message({message: '获取门店失败', type: 'error'});
          }
        });
        let userInfo = this.$utils.getSysUser();
        let storeId = params.filter((item) => item.prop === "storeId" || item.prop === 'storeIds')[0];
        if (!userInfo.storeId) {
          storeId.disabled = false;
          this.storeChange({storeId: ''});
        } else {
          storeId.disabled = true;
          storeId.defaultValue = userInfo.storeId;
        }
      },
      //选择门店
      storeChange(form) {
        form.supplierId = ''
        if (this.$refs["listOperation"]) {
          this.$refs["listOperation"].clearTableData();
        }
        if (form.storeId) {
          this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {
            storeId: form.storeId,
            type: 20
          }).then(data => {
            if (data.code === 200) {
              this.listFormOptions.columns.filter((item) => item.prop === "supplierId")[0].data = data.data;
            } else {
              this.$message({message: '门店获取供应商失败', type: 'error'});
            }
          });
        }
      },
      // 选择供应商
      supplierChange() {
        let form = this.$refs.listOperationForm.getFormModel();
        if (!form.storeId) {
          this.$message.warning("请选择门店");
          return;
        }
        if (!form.supplierId) {
          this.$message.warning("请选择供应商")
          return;
        }
        if (form.supplierId) {
          const loading = this.$loading({
            lock: true,
            text: '数据加载中，请稍候...',
            background: 'rgba(225, 225, 225, 0.8)',
          });
          this.$refs['listOperation'].clearTableData();
          this.$axios.fetchPost(api.settle.jointSettlementOrder, {supplierId: form.supplierId}).then(data => {
            if (data.code === 200) {
              if (data.data.length > 0) {
                //为表格赋值
                data.data.map((item, index) => {
                  item.id = index + 1
                });
                this.$refs['listOperation'].addMoreRow(data.data, 0);
              } else {
                this.$message({message: "此供应商无单据数据", type: "warning"});
              }
            } else {
              this.$message({message: '供应商获取未完成结算的联营对账单失败', type: 'error'});
            }
          }).finally(() => {
            loading.close()
          });
        }
      },
      selectShowChange(selectRows) {
        let billAmount = 0;
        selectRows.map(item => {
          billAmount = billAmount + parseFloat(item.actualPayAmount);
        });
        this.dataRows = selectRows;
        this.$refs.listOperationForm.formModel.billAmount = billAmount.toFixed(2);
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/page/settle/supplier/JointSettlementAdd.vue